export const myFitmentsOptions: any = {
  maxColumnsInSearch: 10, // year, make, model, + 7 other columns
};
